module.exports = __webpack_public_path__ + "static/media/feature-icon-share.7517bc44.svg";